export default __webpack_public_path__ + "static/media/027-safety-code.1721f843.png";